import { render, staticRenderFns } from "./SidebarProductEntry.vue?vue&type=template&id=173298ba&"
import script from "./SidebarProductEntry.vue?vue&type=script&lang=js&"
export * from "./SidebarProductEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports